import { CodyIcon } from '../components/CodyLogo';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export default function Privacy() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <header className="bg-white border-b border-[#E6E8EE] sticky top-0 z-40">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center gap-3">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-sm text-[#5B667A] hover:text-[#0B0F17]"><ArrowLeft className="w-4 h-4" /> Back</button>
          <div className="ml-auto"><CodyIcon size={28} /></div>
        </div>
      </header>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-3xl font-extrabold mb-2" style={{ fontFamily: "'Space Grotesk'" }}>Privacy Policy</h1>
        <p className="text-sm text-[#5B667A] mb-8">Last updated: March 21, 2026</p>
        <div className="prose prose-sm max-w-none text-[#374151] space-y-6">
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>1. Information We Collect</h2>
            <p>We collect information you provide directly, including your email address, password, and website URLs you submit for analysis. We also collect usage data such as pages visited, features used, and leads viewed.</p>
            <p><strong>Account Information:</strong> Email address, hashed password, billing information, and business details you provide during onboarding.</p>
            <p><strong>Website Data:</strong> When you submit a URL, we scrape publicly available content to extract product descriptions and keywords. We do not access password-protected or private content.</p>
            <p><strong>Reddit Data:</strong> We collect publicly available Reddit posts from subreddits you choose to monitor. This data is publicly accessible and collected via Reddit's public RSS feeds.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>2. How We Use Your Information</h2>
            <p>We use the information we collect to:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Provide, maintain, and improve our services</li>
              <li>Generate keywords and monitor subreddits based on your website content</li>
              <li>Score Reddit posts for buyer intent using AI</li>
              <li>Generate AI-powered reply suggestions</li>
              <li>Send notifications about new leads (if configured)</li>
              <li>Process payments and manage your subscription</li>
              <li>Communicate with you about your account and our services</li>
            </ul>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>3. Data Storage and Security</h2>
            <p>Your data is stored securely using industry-standard encryption. Passwords are hashed using bcrypt. We use HTTPS for all data transmission. We retain your data for as long as your account is active or as needed to provide services.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>4. Third-Party Services</h2>
            <p>We use the following third-party services:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li><strong>OpenAI:</strong> For AI-powered keyword extraction, intent scoring, and reply generation. Your data may be processed by OpenAI's servers.</li>
              <li><strong>Reddit:</strong> We access publicly available Reddit data via RSS feeds.</li>
              <li><strong>MongoDB:</strong> For data storage.</li>
            </ul>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>5. Your Rights</h2>
            <p>You may request deletion of your account and all associated data at any time by contacting us. You can also export your data or update your information through your account settings.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>6. Cookies</h2>
            <p>We use local storage and session storage for authentication tokens and temporary scan data. We do not use tracking cookies.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>7. Changes to This Policy</h2>
            <p>We may update this Privacy Policy from time to time. We will notify you of significant changes by posting the new policy on this page and updating the "Last updated" date.</p>
          </section>
          <section>
            <h2 className="text-lg font-bold text-[#0B0F17]" style={{ fontFamily: "'Space Grotesk'" }}>8. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at <a href="mailto:support@trycody.com" className="text-[#FF4500] hover:underline">support@trycody.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
